import type { ReactNode } from 'react';

import type { ResponsiveSectionLayoutSection } from '@cartwhl/ui/layout/ResponsiveSectionLayout';

import AccountDetails from './AccountDetails';
import PlanBilling from './PlanBilling';

export const PROFILE_SECTION_SLUGS = [
  'account-details',
  'my-team',
  'plan-billing',
] as const;

export type ProfileSectionSlug = (typeof PROFILE_SECTION_SLUGS)[number];

export interface ProfileSection
  extends ResponsiveSectionLayoutSection<ProfileSectionSlug> {}

export interface GetProfileSectionsOptions {
  myTeamContent: ReactNode;
  myTeamMaxWidthClassName?: string;
}

export function getProfileSections({
  myTeamContent,
  myTeamMaxWidthClassName,
}: GetProfileSectionsOptions): ProfileSection[] {
  return [
    {
      slug: 'account-details',
      label: 'Account Details',
      content: <AccountDetails />,
    },
    {
      slug: 'my-team',
      label: 'My Team',
      content: myTeamContent,
      maxWidthClassName: myTeamMaxWidthClassName,
    },
    {
      slug: 'plan-billing',
      label: 'Plan & Billing',
      content: <PlanBilling />,
    },
  ];
}

export function findProfileSection(
  sections: ProfileSection[],
  slug?: string,
): ProfileSection | undefined {
  return sections.find((section) => section.slug === slug);
}
